@let profile = profileStateService.select('profile') | async;
@let subscriptionName =
    subscriptionStateService.select('currentSubscription') | async;

@if (isVisible()) {
    <div
        class="bg-gray-white-700 absolute top-16 right-4 z-50 flex w-72 flex-col rounded-md bg-white shadow-md ring-1 ring-black/5 lg:top-16 dark:bg-gray-900 dark:ring-white/10">
        <span class="secondary-text px-3 py-2">
            <span class="block text-lg">
                {{ profile?.firstName }} {{ profile?.lastName }}
            </span>
        </span>

        <hr class="opacity-30 dark:border-gray-400" />

        <app-navigate-button
            [label]="'Profile'"
            [path]="'/client/profile'"
            [icon]="'pi pi-user'"
            (navigate)="onNavigate($event)" />
        @if (groupType() === 'vendor') {
            <div
                class="group flex cursor-pointer items-center justify-between gap-2 px-3 py-2 leading-relaxed transition-all hover:bg-slate-200 dark:hover:bg-gray-800"
                (click)="onUpgradeSubscription(subscriptionName?.planId ?? '')">
                <div class="secondary-text flex items-center gap-2">
                    <i
                        class="pi pi-briefcase secondary-text font-medium text-black"></i>
                    <p>Subscription</p>
                </div>
                <span
                    class="badge-green bg-color-main primary-text-2 capitalize">
                    {{ subscriptionName?.planName }}
                </span>
            </div>
        }

        <app-navigate-button
            [label]="'Settings'"
            [path]="'/dashboard/client/settings'"
            [icon]="'pi pi-cog'"
            (navigate)="onNavigate($event)" />

        <button
            type="button"
            (click)="onToggleTheme()"
            class="secondary-text focus-visible:ring-primary/60 flex w-full cursor-pointer items-center justify-between px-3 py-2 leading-relaxed transition-all hover:bg-slate-200 focus-visible:ring-2 focus-visible:outline-none dark:hover:bg-gray-800">
            <span class="secondary-text flex items-center gap-2">
                <span
                    class="pi font-medium"
                    [class.pi-sun]="themeService.isDark"
                    [class.pi-moon]="!themeService.isDark"></span>
                <span>Appearance</span>
            </span>
            <span class="text-xs font-medium text-gray-500 dark:text-gray-400">
                {{ themeService.isDark ? 'Dark' : 'Light' }}
            </span>
        </button>

        <hr class="opacity-30 dark:border-gray-400" />

        <button
            type="button"
            (click)="logout()"
            class="secondary-text flex cursor-pointer items-center justify-start gap-2 px-3 py-2 leading-relaxed text-red-800 transition-all hover:bg-slate-200 dark:hover:bg-gray-800">
            <span class="pi pi-sign-out font-medium"></span>
            <span>Logout</span>
        </button>
    </div>
}
